import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { SaaSShell, SageChatWidget } from '@roselabs-io/saas-shell'
import { AuthProvider, fetchUserTeams, defaultTeamPath, useAuth } from './lib/auth'
import { BillingProvider } from './context/BillingContext'
import { AppsProvider } from './context/AppsContext'
import { Header, Footer, CookieConsent, ErrorBoundary } from './components'
import { falconConfig } from './config'

// Sage Chat Widget configuration
const SAGE_API_KEY = import.meta.env.VITE_SAGE_SUPPORT_API_KEY
const SAGE_API_URL = import.meta.env.VITE_SAGE_API_URL

function SupportChatWidget() {
  const { user } = useAuth()

  if (!SAGE_API_KEY) return null

  return (
    <SageChatWidget
      apiKey={SAGE_API_KEY}
      apiUrl={SAGE_API_URL}
      primaryColor="#8B6544"
      product="falcon"
      visitor={user ? { email: user.email, name: user.name } : undefined}
    />
  )
}

// Marketing Pages
import LandingPage from './pages/LandingPage'
import DocsPage from './pages/DocsPage'
import ContactPage from './pages/ContactPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'

// Public pages (no auth)
import PublicStatusPage from './pages/PublicStatusPage'

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider fetchUserTeams={fetchUserTeams} defaultTeamPath={defaultTeamPath}>
          <BillingProvider>
            <AppsProvider>
              <Toaster position="top-right" />
              <Routes>
                {/* Marketing routes with Header/Footer */}
                <Route
                  path="/"
                  element={
                    <div className="min-h-screen">
                      <Header />
                      <LandingPage />
                      <Footer />
                    </div>
                  }
                />
                <Route path="/docs" element={<DocsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />

                {/* Public status page (no header/footer) */}
                <Route path="/status/:slug" element={<PublicStatusPage />} />

                {/* SaaSShell handles everything else (auth, settings, billing, product pages, etc.) */}
                <Route path="/*" element={<SaaSShell config={falconConfig} />} />
              </Routes>
              <CookieConsent />
              <SupportChatWidget />
            </AppsProvider>
          </BillingProvider>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  )
}
